export default __webpack_public_path__ + "static/media/a10.ff329521.png";